import React from "react";
import physiomatica from "../images/physiomatica.png";
import caratlane from "../images/caratlane.png";
import youtube from "../images/youtube.png";
import spotify from "../images/spotify.png"
import crypto from "../images/crypto.png";
import ecommerce from "../images/ecommerce.png";
import modernui from "../images/modernUi.png";




const Portfolio = () => {
  const portfolios = [
    {
      id: 1,
      src: physiomatica,
      name:"Clinic Management",
      link:"https://github.com/faiz86Ahmad",
      live:"https://www.physiomatica.com"
    },
    {
      id: 2,
      src: caratlane,
      name:"Jewellary Web",
      link:"https://github.com/faiz86Ahmad",
      live:"http://www.caratglitz.com"
    },
    {
      id: 3,
      src: youtube,
      name:"Youtub Clone",
      link:"https://github.com/faiz86Ahmad",
      live:"https://faizyoutubeclone.netlify.app/"
    },
    {
      id: 4,
      src: spotify,
      name:"spotify Clone",
      link:"https://github.com/faiz86Ahmad",
      live:"https://faizspotifyclone.netlify.app/"
    },
    {
      id: 5,
      src: crypto,
      name:"Cryptocurrency App",
      link:"https://github.com/faiz86Ahmad/mernEcommerceApp",
      live:"https://faizcryptocurrencyapp.netlify.app/"
    },
    {
      id: 6,
      src: ecommerce,
      name:"Ecommerce App",
      link:"https://github.com/faiz86Ahmad/weatherweb",
      live:"https://faizecommercewebapp.netlify.app/"
    },
    {
      id: 7,
      src: modernui,
      name:"Modern UI/UX AI-GTP_3",
      link:"https://github.com/faiz86Ahmad/corona",
      live:"https://faizmodernuiwebsite.netlify.app/"
    },
  ];

  return (
    <div
      name="portfolio"
      className="bg-gradient-to-b from-black to-gray-800 w-full text-white md:h-screen"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Portfolio
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {portfolios.map(({ id, src,name,link,live }) => (
            <div key={id} className="shadow-md shadow-gray-600 rounded-lg">
              <img
                src={src}
                alt=""
                className="rounded-md duration-200 hover:scale-105"
              />
              <p className="flex py-2 justify-center">{name}</p>
              <div className="flex items-center justify-center">
                
                <a href={live} target="_blank"  rel="noreferrer" className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
                  Demo
                </a>
                <a href={link} target="_blank"  rel="noreferrer" className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
                  Code
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
